import React, { ReactNode } from 'react';

import { LinearProgress } from '@material-ui/core';

import TranslationHelper from '../../../../../../../helpers/TranslationHelper';

import { IContract } from '../../../../../../../models/customerService';
import PaneHeader from '../../../../../../../components/PaneHeader';
import ContractForm from '../../Contract/ContractForm';
import { useTaskPaneLoading } from '../../../../../../../state/ui/customerService/bottomGrid/tasks/index.hooks';
import { BLANK_FORM_CONTRACT } from '../../ClientsAndLocations/blankForms';
interface IOwnProps {
    contract?: IContract;
    handleClose: () => void;
    titleComponent?: ReactNode;
}
const ContractPane = ({ contract, handleClose, titleComponent }: IOwnProps) => {
    const paneLoading = useTaskPaneLoading();

    const initialValues = { ...BLANK_FORM_CONTRACT, ...contract };

    return (
        <>
            <PaneHeader
                onCloseClick={handleClose}
                title={TranslationHelper.translate('Contract')}
                titleComponent={titleComponent}
            />

            {paneLoading || !contract ? (
                <LinearProgress />
            ) : (
                <ContractForm initialValues={initialValues} />
            )}
        </>
    );
};
export default ContractPane;
